import {LocationHelper, RequestHelper} from '@/helpers/index';
import {DEALERS} from '@/factories';

const host = LocationHelper.getHost();
export default {
    isDealer() {
        return DEALERS[host] !== undefined || RequestHelper.getQueryVariable('daid') !== null;
    },
}